module.exports = __webpack_public_path__ + "img/sg.png";